import React, {useEffect, useState} from 'react';
import {useRef} from 'react';
import {Animated, Image, View} from 'react-native';
import {primaryColor500} from './utils';

const ViewBarcode = () => {
   const [isVisible, setIsVisible] = useState(true);
   const fadeAnim = React.useRef(new Animated.Value(1)).current;
   const isVisibleRef = useRef(isVisible);

   useEffect(() => {
      isVisibleRef.current = isVisible;
   }, [isVisible]);

   useEffect(() => {
      const interval = setInterval(() => {
         setIsVisible(prevIsVisible => !prevIsVisible);
         Animated.timing(fadeAnim, {
            toValue: isVisibleRef.current ? 0 : 1,
            duration: 500,
            useNativeDriver: true,
         }).start();
      }, 2000);

      return () => clearInterval(interval);
   }, []);

   return (
      <>
         <View
            style={{
               position: 'absolute',
               alignItems: 'center',
               alignContent: 'center',
               justifyContent: 'center',
               height: '100%',
            }}>
            {isVisible && (
               <Animated.View style={{opacity: fadeAnim, alignItems: 'center'}}>
                  <View
                     style={{
                        backgroundColor: primaryColor500,
                        borderRadius: 50,
                        padding: 10,
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                     }}>
                     <Image
                        source={require('../assets/qr_search.png')}
                        style={{width: 13.5, height: 13.5}}
                     />
                  </View>
               </Animated.View>
            )}
         </View>
      </>
   );
};

export default ViewBarcode;
